import { useState } from "react";
import api from "@/lib/api";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogTrigger, DialogFooter } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { KeyRound } from "lucide-react";
import { toast } from "sonner";

export function ChangePassword() {
  const [open, setOpen] = useState(false);
  const [cur, setCur] = useState("");
  const [next, setNext] = useState("");
  const [confirm, setConfirm] = useState("");
  const [busy, setBusy] = useState(false);

  const reset = () => { setCur(""); setNext(""); setConfirm(""); };

  const submit = async (e) => {
    e.preventDefault();
    if (next.length < 8) { toast.error("New password must be at least 8 characters."); return; }
    if (next !== confirm) { toast.error("New passwords don't match."); return; }
    setBusy(true);
    try {
      await api.post("/auth/change-password", { current_password: cur, new_password: next });
      toast.success("Password updated.");
      reset(); setOpen(false);
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Couldn't change password.");
    } finally { setBusy(false); }
  };

  return (
    <Dialog open={open} onOpenChange={(o) => { setOpen(o); if (!o) reset(); }}>
      <DialogTrigger asChild>
        <button data-testid="change-password-btn" title="Change your password"
          className="inline-flex items-center gap-1.5 px-2 py-1 text-[11px] uppercase tracking-wider text-muted-foreground hover:text-foreground transition-colors">
          <KeyRound size={13} /> <span className="hidden sm:inline">Password</span>
        </button>
      </DialogTrigger>
      <DialogContent className="bg-card border-2 border-foreground rounded-none max-w-sm" data-testid="change-password-dialog">
        <DialogHeader>
          <DialogTitle className="font-display text-3xl uppercase flex items-center gap-2">
            <KeyRound className="text-primary" size={22} /> Change Password
          </DialogTitle>
          <DialogDescription className="font-data text-xs">Enter your current password, then choose a new one (min 8 characters).</DialogDescription>
        </DialogHeader>
        <form onSubmit={submit} className="space-y-3">
          <Input type="password" autoComplete="current-password" placeholder="Current password"
            value={cur} onChange={(e) => setCur(e.target.value)} data-testid="cp-current" className="rounded-none" />
          <Input type="password" autoComplete="new-password" placeholder="New password"
            value={next} onChange={(e) => setNext(e.target.value)} data-testid="cp-new" className="rounded-none" />
          <Input type="password" autoComplete="new-password" placeholder="Confirm new password"
            value={confirm} onChange={(e) => setConfirm(e.target.value)} data-testid="cp-confirm" className="rounded-none" />
          <DialogFooter>
            <Button type="submit" disabled={busy} data-testid="cp-submit"
              className="rounded-none bg-primary text-primary-foreground uppercase text-xs font-bold w-full">
              {busy ? "Saving…" : "Update password"}
            </Button>
          </DialogFooter>
        </form>
      </DialogContent>
    </Dialog>
  );
}
